// Helpers da tela "Log > Atualizações".
//
// O backend (GET/POST /atualizacoes) devolve, por marca, o horário da última
// escrita de cada cache do Redis. O valor é gravado pelo ETL com
// `new Date().toLocaleString("pt-BR", { timeZone: "America/Sao_Paulo" })`,
// ou seja, no formato "DD/MM/AAAA, HH:mm:ss". Quando o cache nunca foi
// gravado (ou a leitura falhou) vem `null` / uma mensagem de erro.

// Rótulos amigáveis das colunas — as chaves são as do payload da API.
export const LABELS_COLUNAS = {
  MARCA: 'Marca',
  CATALOGO: 'Catálogo',
  SKUS: 'SKUs',
  ATRIBUTOS: 'Atributos',
  API: 'API',
  GESTAO: 'Gestão',
  ESTUDIO: 'Estúdio',
  ESTOQUE_CD: 'Estoque CD',
  MARKETPLACE: 'Marketplace',
};

// Rótulos amigáveis das marcas — as chaves são os tokens usados nas chaves do
// Redis (sem espaço/acento), como o backend monta em services/log.js.
export const LABELS_MARCAS = {
  ANIMALE: 'Animale',
  FARM: 'Farm',
  FOXTON: 'Foxton',
  FABULA: 'Fábula',
  BYNV: 'NV',
  CRISBARROS: 'Cris Barros',
  MARIAFILO: 'Maria Filó',
  OFF: 'Off Premium',
  HERING: 'Hering',
  CAROLBASSI: 'Carol Bassi',
  RESERVA: 'Reserva',
};

export const rotuloColuna = (chave) => LABELS_COLUNAS[chave] || chave;
export const rotuloMarca = (marca) => LABELS_MARCAS[marca] || marca;

// Converte "DD/MM/AAAA, HH:mm:ss" (ou só "DD/MM/AAAA") em Date.
// Retorna null para qualquer valor que não siga esse formato — inclusive as
// mensagens de erro que o consultaCache do backend devolve como string.
export const parseDataBr = (valor) => {
  if (typeof valor !== 'string') return null;

  const match = valor
    .trim()
    .match(/^(\d{2})\/(\d{2})\/(\d{4})(?:,?\s+(\d{2}):(\d{2})(?::(\d{2}))?)?$/);

  if (!match) return null;

  const [, dia, mes, ano, hora = '0', minuto = '0', segundo = '0'] = match;
  const data = new Date(
    Number(ano),
    Number(mes) - 1,
    Number(dia),
    Number(hora),
    Number(minuto),
    Number(segundo)
  );

  return isNaN(data.getTime()) ? null : data;
};

// Classifica a célula pela "idade" da atualização, em dias cheios de calendário:
//   ok        -> atualizado hoje (o esperado, já que os ETLs rodam diariamente)
//   atencao   -> atualizado ontem
//   atrasado  -> dois dias ou mais sem atualizar
//   vazio     -> sem data (cache nunca gravado ou erro de leitura)
export const statusAtualizacao = (valor) => {
  const data = parseDataBr(valor);
  if (!data) return 'vazio';

  const hoje = new Date();
  const inicioHoje = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
  const inicioData = new Date(data.getFullYear(), data.getMonth(), data.getDate());

  const dias = Math.round((inicioHoje - inicioData) / 86400000);

  if (dias <= 0) return 'ok';
  if (dias === 1) return 'atencao';
  return 'atrasado';
};

// Texto curto com o tempo decorrido ("há 3 h", "há 2 d"), exibido abaixo do
// horário para dar a noção de atraso sem precisar fazer a conta mentalmente.
export const idadeRelativa = (valor) => {
  const data = parseDataBr(valor);
  if (!data) return '';

  const minutos = Math.floor((Date.now() - data.getTime()) / 60000);

  if (minutos < 1) return 'agora';
  if (minutos < 60) return `há ${minutos} min`;

  const horas = Math.floor(minutos / 60);
  if (horas < 24) return `há ${horas} h`;

  const dias = Math.floor(horas / 24);
  return `há ${dias} d`;
};
